import { PageRef } from 'providers/page-ref';
import { ExerciseDiffEntry, ExerciseDiffField } from 'services/exercise-diff';

// Result delivered to the caller's `returnCallback` via `popAsync(result)`.
//   - 'apply'  : user committed a selection (full or partial).
//   - 'ignore' : explicit "Ignore" button — dismiss the update (mark the rev seen).
// A plain back / close (header X / hardware-back) pops with NO result (undefined),
// which the caller treats as 'cancel' — nothing is written, the update stays unresolved.
export type ExerciseDiffResult =
  | { action: 'apply'; appliedFields: Set<ExerciseDiffField> }
  | { action: 'ignore' };

export type ExerciseDiffPageParams = {
  returnCallback: string; // REQUIRED: method on the parent that receives ExerciseDiffResult | undefined
  local?: {
    // the per-field diff to present. lives in `local` because nav rejects non-primitive
    // top-level params (ValidNavParams) — `local` is kept in ephemeral in-memory store.
    diff: ExerciseDiffEntry[];
  };
};

export const IExerciseDiffPage: PageRef<ExerciseDiffPageParams, ExerciseDiffResult> = {
  pageName: 'ExerciseDiffPage',
} as PageRef<ExerciseDiffPageParams, ExerciseDiffResult>;
